import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const customStylesSelect = {
    container: (base) => ({
      ...base,
      width: '100%',
    }),
    valueContainer: (base) => ({
        ...base,
        paddingLeft: '35px !important',
        background: 'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmls' +
            'bD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bG' +
            'U9ImV2ZW5vZGQiIGQ9Ik04LjMzNDEgMTUuNjY2N0MxMi4zODQ2IDE1LjY2NjcgMTUuNjY4MiAxMi4zODM0IDE1LjY2ODIgOC4zMzMzM0Mx' +
            'NS42NjgyIDQuMjgzMjUgMTIuMzg0NiAxIDguMzM0MSAxQzQuMjgzNTkgMSAxIDQuMjgzMjUgMSA4LjMzMzMzQzEgMTIuMzgzNCA0LjI4Mz' +
            'U5IDE1LjY2NjcgOC4zMzQxIDE1LjY2NjdaIiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS13aWR0aD0iMS4zIi8+CjxwYXRoIGQ9Ik0xMy41' +
            'IDEzLjVMMjEgMjEiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLXdpZHRoPSIxLjMiLz4KPC9zdmc+Cg==) no-repeat left 10px center',
    }),
    input: (base) => ({
        ...base,
        color: COLORS.white,
    }),
};

export const Content = styled.div`
    display: block;
    position: relative;
    width: 100%;
    margin-top: 12px;
    margin-bottom: -50px;
    padding-top: 10px;
    padding-bottom: 60px;
    color: ${COLORS.black};
    background-color: ${COLORS.white};
    overflow: hidden;
`;

export const InnerWrap = styled.div`
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 9%;

    @media screen and (max-width: 1188px) {
        padding: 0 6%;
    }
`;

export const Title = styled.h1`
    margin-bottom: 30px;
    width: 100%;
    ${FONTS.H1};
`;

export const FeedbackWrap = styled.div`
    flex-direction: column;
    margin-bottom: 50px;
    width: 100%;
    padding: 30px 30px 20px;
    background-color: ${COLORS.outlineGrey};
`;

export const FeedbackLinksWrap = styled.div`
    margin: 0 -20px 0;
`;

export const FeedbackLink = styled.a`
    display: flex;
    align-items: flex-end;
    margin: 0 20px 10px;
    ${FONTS.MediumS};
    color: ${COLORS.blue};
    transition: color .2s linear;

    &:hover {
        color: ${COLORS.red};
    }

    &::before {
        margin-right: 10px;
        color: ${COLORS.black};
        content: '';
        width: 25px;
        height: 25px;
        font-family: 'icomoon';
        font-size: 28px;
    }
`;

export const HeadPhoneLink = styled(FeedbackLink)`
    &::before {
        content: '\\e648';
    }
`;

export const BlockNoteLink = styled(FeedbackLink)`
    &::before {
        content: '\\e615';
    }
`;

export const FeedbackTitle = styled.h2`
    margin-bottom: 20px;
    ${FONTS.H2};
`;

export const FilterWrap = styled.div`
    margin: 0 -15px 15px -15px;
    align-items: center;
    width: 100%;
`;

export const SelectWrap = styled.div`
    position: relative;
    flex: 1 0 270px;
    max-width: 420px;
    margin: 0 15px 15px;
`;

export const SwitcherWrap = styled.div`
    margin: 0 15px 15px;
`;

export const MapWrap = styled.div`
    margin-bottom: 50px;
    padding-top: 20px;
    height: 440px;
`;

// Список контактов
export const ContactsWrap = styled.div``;

export const ContactList = styled.div`
    flex-direction: column;
`;

export const BlockTitle = styled.h2`
    margin-bottom: 18px;
    ${FONTS.H2};
`;

export const ElemDescription = styled.div`
    flex-direction: column;
    align-items: flex-start;
`;

export const ElemTime = styled.div`
    ${FONTS.XS};
`;
